module.exports = __webpack_public_path__ + "static/media/Building_Community_Thumb.04ffe7bb.png";